import { Component, OnInit, Input, Host, EventEmitter, Output, ViewChild } from '@angular/core';
import { ObjectProperties } from '../../../../../../../../../../common/components/data-table/models/column.interface';
import { Feature, LayerManagerComponent } from '../layer-manager.component';
import { Layer } from "../models/layers.model";
import * as jp from 'jsonpath';
import { map } from 'rxjs/operators';
import { LunaGisLayersService } from '../../../../../../../../../../gis/services/luna-gis-layers.service';
import { FormGroup, FormControl } from '@angular/forms';
import { PropertySelectorComponent } from '../../../../data-table-config/column-mapper/column-item/property-selector/property-selector.component';
import { PropertyNodeComponent } from '../../../../data-table-config/column-mapper/column-item/property-selector/property-node/property-node.component';

@Component({
    selector: 'layer',
    templateUrl: './layer.component.html',
    styleUrls: ['./layer.component.scss'],
    standalone: false
})
export class LayerComponent implements OnInit {
    @Input()
    services: ObjectProperties[] = [];
    @Input()
    item: Layer;
    @Output()
    itemChange: EventEmitter<Layer> = new EventEmitter();
    @ViewChild(PropertySelectorComponent)
    propertySelector: PropertySelectorComponent;

    customSource: boolean = false;
    inEdit: boolean = false;
    form: FormGroup;

    constructor(
        @Host() public _layerManager: LayerManagerComponent,
        public _lunaGISLayerService: LunaGisLayersService
    ) { }

    ngOnInit() {
        if (this.item.isConditional === undefined) this.item.isConditional = false;
        this.form = new FormGroup({
            title: new FormControl(this.item.title),
            identifier: new FormControl(this.item.identifier),
            layerInformation: new FormControl(this.item.layerInformation),
            customSource: new FormControl(this.item.customSource)
        });

        this.customSource = !!this.form.controls.customSource.value;
    }

    selectLayer(layer: ObjectProperties) {
        this.form.controls.layerInformation.setValue(layer.data);
    }

    toggleCustomSource(e: boolean) {
        if (e === undefined || e === null)
            return;

        this.customSource = e;

        if (this.customSource)
            this.form.controls.layerInformation.setValue(null);
        else
            this.form.controls.customSource.setValue(null);
    }

    delete() {
        this._layerManager.removeLayer(this.item);
    }

    save() {
        for (var prop in this.form.controls)
            this.item[prop] = this.form.controls[prop].value;

        this.inEdit = !this.inEdit;
    }

    cancel() {
        for (var prop in this.item)
            this.form.controls[prop].setValue(this.item[prop]);

        this.inEdit = !this.inEdit;
    }

    loadLayer(item: PropertyNodeComponent) {
        if (!(item.object as any).loaded) {
            (item.object as any).loaded = true;
            this._loadFeatureLayers(item.object).subscribe((r) => {
                (item.object.content as any) = r;
                item.menuItem.changeDetectorRef.detectChanges();
                item.changeDetector.detectChanges();
            }, () => (item.object as any).loaded = false);
        }
    }

    public _loadFeatureLayers(item: ObjectProperties): any {
        let service = jp.value(this._layerManager.services, item.path);
        return this._lunaGISLayerService.getServiceLayers(service.attributes.link).pipe(map((result: any) => {
            if (result.layers)
                return this._createMappings(service, item, result.layers).content;
            else
                return [];
        }));
    }

    public _createMappings(service: Feature, parent: ObjectProperties, layers: any): ObjectProperties {
        layers.forEach((x, idx) => {
            let node = {
                name: x.name,
                path: `${parent.path}.${idx}`,
                content: [],
                data: { ...x, url: `${service.attributes.link}/${x.id}` }
            } as ObjectProperties;

            parent.content.push(node);
        });

        return parent;
    }
}
